import { useState } from 'react';
import { useT } from '@/lib/i18n';
import { openAppUpdate, useAppUpdate } from '@/lib/app-update';
import { Icon } from './Icon';

export function AppUpdateBanner() {
  const t = useT();
  const update = useAppUpdate();
  const info = update.data;
  const [status, setStatus] = useState<
    'idle' | 'downloading' | 'permission' | 'error'
  >('idle');

  if (!info) return null;
  const updateInfo = info;

  async function startUpdate() {
    setStatus('downloading');
    try {
      await openAppUpdate(updateInfo);
      setStatus('downloading');
    } catch (error) {
      const text = String(error);
      setStatus(text.includes('install_permission') ? 'permission' : 'error');
    }
  }

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-heritage-200 bg-surface px-4 py-3 shadow-sm">
      <div className="flex min-w-0 items-center gap-2">
        <span className="rounded-xl bg-heritage-100 p-2 text-heritage-700">
          <Icon name="refresh" className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold">
            {t('Доступно обновление приложения')}
          </p>
          <p className="text-xs text-heritage-500">
            {t('Версия {version}', { version: updateInfo.version })}
          </p>
          {status === 'downloading' && (
            <p className="mt-1 text-xs text-heritage-600">
              {t('Загрузка обновления… Установка начнётся автоматически.')}
            </p>
          )}
          {status === 'permission' && (
            <p className="mt-1 text-xs text-amber-700">
              {t('Разрешите установку из этого приложения и нажмите «Обновить» снова.')}
            </p>
          )}
          {status === 'error' && (
            <p className="mt-1 text-xs text-red-700">
              {t('Не удалось загрузить обновление. Попробуйте ещё раз.')}
            </p>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={() => void startUpdate()}
        disabled={status === 'downloading'}
        className="btn-primary"
      >
        {status === 'downloading'
          ? t('Загрузка…')
          : t('Обновить до {version}', { version: updateInfo.version })}
      </button>
    </section>
  );
}
